import { Theme } from '../../infrastructure/storage/LocalStorageService';

export const tokens = {
  dark: {
    bg: '#0f0f1a',
    bgSurface: '#1a1a2e',
    bgCard: '#16213e',
    bgElevated: '#0d1b2a',
    border: '#2a2a4a',
    primary: '#7c3aed',
    primaryLight: '#9d5bf5',
    primaryDark: '#5b21b6',
    accent: '#06b6d4',
    accentLight: '#22d3ee',
    success: '#10b981',
    warning: '#f59e0b',
    danger: '#ef4444',
    text: '#e2e8f0',
    textMuted: '#94a3b8',
    textFaint: '#475569',
    cardFace: '#1e1b4b',
    cardBack: '#312e81',
    cardBorder: '#4c1d95',
    shadow: 'rgba(0,0,0,0.5)',
    tableGreen: '#064e3b',
    tableFelt: '#065f46',
    tableEdge: '#047857',
  },
  light: {
    bg: '#f1f5f9',
    bgSurface: '#ffffff',
    bgCard: '#f8fafc',
    bgElevated: '#e2e8f0',
    border: '#cbd5e1',
    primary: '#7c3aed',
    primaryLight: '#9d5bf5',
    primaryDark: '#5b21b6',
    accent: '#0891b2',
    accentLight: '#06b6d4',
    success: '#059669',
    warning: '#d97706',
    danger: '#dc2626',
    text: '#1e293b',
    textMuted: '#475569',
    textFaint: '#94a3b8',
    cardFace: '#ede9fe',
    cardBack: '#ddd6fe',
    cardBorder: '#7c3aed',
    shadow: 'rgba(0,0,0,0.15)',
    tableGreen: '#d1fae5',
    tableFelt: '#a7f3d0',
    tableEdge: '#6ee7b7',
  },
};

export type TokenSet = typeof tokens.dark;

export function getTokens(theme: Theme): TokenSet {
  return tokens[theme];
}
